<div class="app-nav-item" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">
  <ng-content select="[trigger]"></ng-content>
</div>
<mat-menu #menu="matMenu" [hasBackdrop]="false" class="domain-menu">
  <div>
    <ng-content select="[content]"></ng-content>
  </div>
</mat-menu>